import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { HiMenuAlt3, HiX } from 'react-icons/hi';
import './Navbar.css';

const navLinks = [
  { to: 'about', label: 'About' },
  { to: 'experience', label: 'Experience' },
  { to: 'projects', label: 'Projects' },
  { to: 'skills', label: 'Skills' },
  { to: 'education', label: 'Education' },
  { to: '/cv', label: 'CV', isRoute: true },
  { to: 'contact', label: 'Contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 30);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Prevent background scrolling when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  // Close menu on Escape key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      {/* Backdrop overlay for mobile drawer */}
      <div
        className={`navbar__backdrop ${menuOpen ? 'navbar__backdrop--visible' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />

      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <div className="navbar__inner container">
          <ScrollLink
            to="hero"
            smooth="easeOutCubic"
            duration={350}
            className="navbar__logo"
            onClick={() => setMenuOpen(false)}
          >
            <span className="navbar__logo-bracket">[</span>
            <span className="navbar__logo-name">Sudip Majkoti</span>
            <span className="navbar__logo-dot">.</span>
            <span className="navbar__logo-bracket">]</span>
          </ScrollLink>

          <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            <div className="navbar__drawer-header">
              <span className="navbar__drawer-title">[ NAVIGATION ]</span>
              <button
                className="navbar__drawer-close"
                onClick={() => setMenuOpen(false)}
                aria-label="Close navigation"
              >
                <HiX />
              </button>
            </div>

            {navLinks.map((link) => (
              <li key={link.to}>
                {link.isRoute ? (
                  <RouterLink
                    to={link.to}
                    onClick={() => setMenuOpen(false)}
                  >
                    {link.label}
                  </RouterLink>
                ) : (
                  <ScrollLink
                    to={link.to}
                    smooth="easeOutCubic"
                    duration={350}
                    offset={-70}
                    spy
                    activeClass="active"
                    onClick={() => setMenuOpen(false)}
                  >
                    {link.label}
                  </ScrollLink>
                )}
              </li>
            ))}
          </ul>

          <div className="navbar__actions">
            <button
              className="navbar__toggle"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
            >
              {menuOpen ? <HiX /> : <HiMenuAlt3 />}
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
